import * as React from 'react'

import { AvailablePaymentMethodsProvider } from '../../../segments/PaymentMethods'
import { useLockedOrderCtx } from './LockedOrderProvider'

type TProps = RequiredChildren

/**
 * Wraps the `AvailablePaymentMethodsProvider` for the locked order context.
 * - use `useAvailablePaymentMethodsCtx` to access the payment methods
 */
export const LockedOrderAvailablePaymentMethodsProvider: React.FC<TProps> = ({ children }) => {
  const order = useLockedOrderCtx()

  return <AvailablePaymentMethodsProvider order={order}>{children}</AvailablePaymentMethodsProvider>
}
